<template>
  <div v-if="isHighlight" class="place-departure pl-5 font-bold">
    {{placeDate}} {{getLabel()}} {{getTimeZone()}}
  </div>
  <div v-else class="pl-5 font-bold" :class="{'place-date-in-japan': inJapan, 'place-date': !inJapan}">
    {{placeDate}}
  </div>
</template>

<script>
export default {
  props: {
    date: {
      type: Object
    },
    isDeparture: {
      type: Boolean,
      default: function () {
        return true
      }
    },
    inJapan: {
      type: Boolean,
      default: function () {
        return true
      }
    },
    isHighlight: {
      type: Boolean,
      default: function () {
        return true
      }
    }
  },
  computed: {
    placeDate: function () {
      return this.date.format("YYYY年MM月DD日")
    }
  },
  methods: {
    getLabel: function () {
      if (this.isDeparture) {
        return "出発"
      } else {
        return "到着"
      }
    },
    getTimeZone: function () {
      if (this.inJapan) {
        return "(日本時間)"
      } else {
        return "(ハワイ時間)"
      }
    }
  }
}
</script>
